import { CalendarMonth as e } from "./CalendarMonth.mjs";
import { InlineSingle as t } from "../styled/Popups.styled.mjs";
import { useCalendarNavigation as n } from "../hooks/useCalendarNavigation.mjs";
import "react";
import { useTranslation as r } from "@maat/store-i18n";
import { jsx as i } from "react/jsx-runtime";
//#region src/components/DatePicker/components/DateCalendar.tsx
var a = ({ value: a, onChange: o, minDate: s, maxDate: c, className: l, annotations: u, blockedRanges: d }) => {
	let { t: f } = r("ds"), { view: p, navigate: m } = n({ initialValue: a });
	return /* @__PURE__ */ i(t, {
		className: l,
		role: "dialog",
		"aria-label": f("ds:datePicker.dialogLabel"),
		children: /* @__PURE__ */ i(e, {
			year: p.year,
			month: p.month,
			onPrev: () => m(-1),
			onNext: () => m(1),
			selectedDate: a,
			onDayClick: (e) => o?.(e),
			minDate: s,
			maxDate: c,
			annotations: u,
			blockedRanges: d
		})
	});
};
//#endregion
export { a as DateCalendar };
